import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DYNAMIC_COMPONENT_DATA } from '@principle-theorem/ng-shared';
import { DtxStudioFeatureService } from '../dtx-studio-feature.service';
import { BridgeDeviceSelectorService } from '../../../bridge-device-selector-dialog/bridge-device-selector.service';
import { IIntegrationActionData } from '../../../../integration-action-data';
import {
  DTX_STUDIO_COMMANDS,
  DTX_STUDIO_INTEGRATION,
  DtxStudioToDeviceCommand,
} from '@principle-theorem/principle-bridge-core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'pr-dtx-studio-integration',
  templateUrl: './dtx-studio-integration.component.html',
  styleUrls: ['./dtx-studio-integration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DtxStudioIntegrationComponent {
  isDisabled$: Observable<boolean>;
  integrationFeatures = DTX_STUDIO_COMMANDS;

  constructor(
    @Inject(DYNAMIC_COMPONENT_DATA)
    private _data: IIntegrationActionData,
    private _dtxStudio: DtxStudioFeatureService,
    private _bridgeDeviceSelector: BridgeDeviceSelectorService
  ) {
    this.isDisabled$ = of(this._data.patient).pipe(
      map((patient) => !patient.dateOfBirth)
    );
  }

  async openDtxStudio(command: DtxStudioToDeviceCommand): Promise<void> {
    const device = await this._bridgeDeviceSelector.selectDevice(
      DTX_STUDIO_INTEGRATION
    );
    if (!device) {
      return;
    }
    await this._dtxStudio.openDtxStudio(
      this._data.patient,
      command,
      device.ref
    );
  }
}
